<template>
        <div id="modal-apply-price-set" class="modal fade" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="container">
                        <div class="row mb-2">
                            <div class="col-6">希望単価</div>
                            <div class="col p-0">
                                <div class="custom-control custom-switch text-danger">
                                    <span v-if="item.price_hope_start == item.price_hope_end">
                                        {{item.price_hope_end}} 万円
                                    </span>
                                    <span v-else>
                                        {{item.price_hope_start}} ~ {{item.price_hope_end}} 万円
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-6">公開単価設定</div>
                            <div class="col p-0">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" v-model="pub" class="custom-control-input" id="customSwitch1">
                                    <label class="custom-control-label" for="customSwitch1">{{this.setLabel}}</label>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-6 pt-2">公開単価開始</div>
                            <div class="col p-0">
                                <select class="form-control" v-model="priceStart" :disabled="priceDisabled">
                                    <option value="0">-- 選択 --</option>
                                    <option v-for="(n,index) in 200" :key="index" :value="n">{{n}}万円</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 pt-2">公開単価終了</div>
                            <div class="col p-0">
                                <select class="form-control" v-model="priceEnd" :disabled="priceDisabled">
                                    <option value="0">-- 選択--</option>
                                    <option v-for="(n,index) in 200" :key="index" :value="n">{{n}}万円</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button class="btn btn-danger" :disabled="!canSet" type="button" @click="applyPricePub">
                        設定する
                    </button>
                    <button class="btn btn-success" type="button" @click="hideThis">
                        &nbsp;&nbsp;閉じる&nbsp;&nbsp;
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        data () {
            return {
                item: {},
                pub: false,
                priceStart: '0',
                priceEnd: '0',
            }
        },
        watch: {
            pub () {
                if (!this.pub) {
                    this.priceStart = '0'
                    this.priceEnd = '0'
                }
            },
            getAppPricePubStatus (status) {
                if (status == 0) {
                    this.$store.dispatch('startSpinner')
                }
                if (status == 2) {
                    this.hideThis()
                    this.$store.dispatch('doneSpinner')
                }
                if (status == 3) {
                    this.hideThis()
                    this.$store.dispatch('doneSpinner')
                }
            }
        },
        computed: {
            canSet () {
                if (!this.pub) {
                    return true
                }
                return this.priceStart != '0' && this.priceEnd != '0' && (Number(this.priceEnd) >= Number(this.priceStart))
            },
            priceDisabled () {
                return !this.pub
            },
            setLabel () {
                return this.pub ? '公開' : '非公開'
            },
            ...mapGetters(['getAppPricePubStatus', 'getAppPricePubliced'])
        },
        methods: {
            openThis (item) {
                this.resetThis()
                this.item = item
                this.priceStart = item.price_pub_start == '0' ? '0' : item.price_pub_start
                this.priceEnd = item.price_pub_end == '0' ? '0' : item.price_pub_end
                this.pub = item.price_pub_end != '0' ? true : false
                $('#modal-apply-price-set').modal('show')
            },
            hideThis () {
                this.resetThis()
                $('#modal-apply-price-set').modal('hide')
            },
            resetThis () {
                this.item = {}
                this.pub = false,
                this.priceStart = '0'
                this.priceEnd = '0'
            },
            applyPricePub () {
                this.$store.dispatch('applyPricePub', {
                    id: this.item.ai_id,
                    pub: this.pub,
                    priceStart: this.pub ? this.priceStart : '0',
                    priceEnd: this.pub ? this.priceEnd : '0'
                })
            }
        }
    }
</script>

<style>

</style>
